export default __webpack_public_path__ + "static/media/14.c393b302.png";